{
  "brand": {
    "name": "Færdo"
  },
  "landing": {
    "description": "Færd means journey in Danish.",
    "tagline": "Start your next journey now."
  },
  "locale": {
    "switchLabel": "Language",
    "en": "English",
    "pl": "Polski"
  },
  "theme": {
    "system": "System theme",
    "dark": "Dark theme",
    "light": "Light theme"
  },
  "newsletter": {
    "label": "The trail opens soon. Be among the first to set off.",
    "emailPlaceholder": "Your email address",
    "cta": "Save my spot",
    "sending": "Packing bags…",
    "success": "Your pack is ready. We'll wave you off when the trail opens.",
    "error": "Something went wrong. Please try again."
  },
  "consent": {
    "message": "We use analytics cookies to understand how you use this site and improve it. You can accept or decline.",
    "accept": "Accept",
    "decline": "Decline"
  }
}
